import { UntypedFormGroup, ValidatorFn } from '@angular/forms';

export const noWhitespaceCharacters: ValidatorFn = (control: UntypedFormGroup): {[key: string]: any} | null => {
  const reg = new RegExp(/^\s/);

  if (control.value != null && control.value.length > 0) {
    if (reg.test(control.value)) {
      return { noWhitespace: true };
    }
  }

  return null;
};
